export const PHONE_REGEX = /^\+7 \(\d{3}\) \d{3} \d{4}$/;
export const PHONE_REGEX2 = /^\+7 \(\d{3}\) \d{3} - \d{4}$/;
